import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import axios from 'axios';
import DOMPurify from 'dompurify';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

/**
 * PrivacyPage - Displays the privacy policy
 */
const PrivacyPage = () => {
  const [content, setContent] = useState('<p>Privacybeleid wordt geladen...</p>');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadPolicy = async () => {
      try {
        const response = await axios.get(`${API}/gdpr/privacy`);
        setContent(response.data.content);
      } catch (error) {
        console.error('Failed to load privacy policy:', error);
        setContent('<p>Kon het privacybeleid niet laden. Probeer het later opnieuw.</p>');
      } finally {
        setIsLoading(false);
      }
    };
    loadPolicy();
  }, []);

  return (
    <div className="min-h-screen bg-[#F5F0E8]">
      {/* Header */}
      <div className="bg-[#1C1C2E] py-8">
        <div className="max-w-4xl mx-auto px-4">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-gray-300 hover:text-white mb-4 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Terug naar home
          </Link>
          <div className="flex items-center gap-4">
            <Shield className="w-10 h-10 text-[#C8963E]" />
            <h1 className="text-3xl font-serif font-bold text-white">Privacybeleid</h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          {isLoading ? (
            <div className="flex items-center justify-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#C8963E]"></div>
            </div>
          ) : (
            <div 
              className="prose prose-lg max-w-none
                prose-headings:font-serif prose-headings:text-[#1C1C2E]
                prose-h2:text-2xl prose-h2:mt-8 prose-h2:mb-4 prose-h2:border-b prose-h2:border-[#C8963E] prose-h2:pb-2
                prose-h3:text-xl prose-h3:mt-6 prose-h3:mb-3
                prose-h4:text-lg prose-h4:mt-4 prose-h4:mb-2
                prose-p:text-[#2C2C3E] prose-p:leading-relaxed
                prose-li:text-[#2C2C3E]
                prose-ul:my-4
                prose-a:text-[#C8963E] prose-a:no-underline hover:prose-a:underline"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
              data-testid="privacy-content"
            />
          )}
        </div>

        {/* Footer links */}
        <div className="mt-8 text-center text-sm text-gray-500">
          <Link to="/cookies" className="text-[#C8963E] hover:underline">Cookiebeleid</Link>
          <span className="mx-2">|</span>
          <button 
            onClick={() => window.openCookieSettings?.()}
            className="text-[#C8963E] hover:underline"
          >
            Cookie-instellingen
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
